import React, {Fragment, useEffect, useRef, useState} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import {Card, Row, Col, Form} from 'react-bootstrap'
import {Button} from 'reactstrap'
import {connect} from "react-redux";
import {getLabels, getReports,uploadXML} from "../../../actions";
import {updateValues} from "../../../actions/BasicActions";
import {CardBody, Input, FormGroup, Label} from "reactstrap";
import FileTable from "../../../views/LoggedUserPages/DataImport/ImportFile/FileTable";
import DataImportPage from "../../../views/LoggedUserPages/DataImport/DataImportPage";
import ReportList from "./ReportList";

const UserUploadDataComponent = ({Basic:{error,reports}, uploadXML}) => {
        const [selectedFile, setSelectedFile] = useState({name:"Sprawozdanie KRS w formacie XML", file:null});
        // const fileInput = useRef(null);
        const fileInput = React.useRef();
        const UploadFile = (e) =>{
                uploadXML(selectedFile.file);
                setSelectedFile({name:"Sprawozdanie KRS w formacie XML", file:null});
        };
    return (

                <Col md={12} lg={12}  className={'ml-auto mr-auto'}>
                    <Card>
                        <CardBody>
                            <Form >
                                <FormGroup className='wskaznikiFile'>
                                    {/* <Label for="import-excel">{`${fileName}`}</Label> */}
                                    <Input innerRef={fileInput} style={{cursor:"pointer"}} className='wskaznikiFile'
                                        type="file"
                                        id="import-xml"
                                        name="xmlFile"
                                        label={`${selectedFile.name}`}
                                        // htmlFor={`${selectedFile.name}`}
                                        lang="pl"
                                        onChange={e=>setSelectedFile({file:e.target.files[0], name:e.target.files[0].name})}
                                    />
                                    <Label for="import-xml" className='custom-file-label'>{selectedFile.name}</Label>
                                </FormGroup>
                                <Row>
                                    <Col className="text-right" off="6" xs={{size:"6",offset:6}}>
                                        <Button type='button' style={{width: '230px'}}
                                            onClick={(e) => UploadFile(e)}
                                            // block className={'btn-aotmit-gradient m-0'}
                                            className="btn-round m-0" color="wskazniki" outline>
                                            <i className="fas fa-upload mr-2"/>
                                            Prześlij plik
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </CardBody>
                    </Card>
                </Col>


    )
};
const mapStateToProps = state => ({
    Basic: state.Basic,

});
export default connect(mapStateToProps, {getReports, getLabels, uploadXML})(UserUploadDataComponent)